export default function Merits() {
  const merits = [
    {
      icon: 'ri-percent-line',
      title: '業界最高水準の1.2%還元率',
      description: '通常のクレジットカード利用で常に1.2%のポイント還元。100円につき1.2ポイントが貯まり、他社の一般的な0.5%還元と比べて2倍以上の高還元率を実現しています。'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: '年会費永年無料',
      description: '年会費は永年無料。高還元率カードでありながら維持費が一切かからないため、コストを気にせず長期的にお得に利用できます。'
    },
    {
      icon: 'ri-store-2-line',
      title: '提携サービスで最大4.2%還元',
      description: '提携の予約サイトや飲食店予約サービスでは、通常の1.2%に加えて最大3%の追加ポイントが貯まり、合計で最大4.2%の超高還元率を実現できます。'
    },
    {
      icon: 'ri-exchange-line',
      title: 'Pontaポイント・dポイントに交換可能',
      description: '貯まったポイントは、Pontaポイントやdポイントに等価交換が可能。使い道が広がり、コンビニや飲食店など日常のさまざまなシーンで活用できます。'
    },
    {
      icon: 'ri-shield-check-line',
      title: '充実した旅行保険',
      description: '海外旅行保険は最高2,000万円、国内旅行保険は最高1,000万円を付帯。さらにショッピング保険も年間200万円まで補償され、安心して利用できます。'
    },
    {
      icon: 'ri-smartphone-line',
      title: '電子マネー・スマホ決済対応',
      description: '楽天Edy、モバイルSuica、Apple Pay、Google Payなど主要な電子マネーとスマホ決済に対応。チャージでもポイントが貯まり、キャッシュレス生活がさらにお得になります。'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-orange-50 via-white to-red-50">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-4">
          高還元率カードのメリット
        </h2>
        <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
          業界最高水準の還元率と充実した特典で、日常のお買い物から旅行まで幅広くお得に利用できます
        </p>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {merits.map((merit, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-orange-300"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-red-500 rounded-xl flex items-center justify-center mb-4">
                <i className={`${merit.icon} text-white text-2xl w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {merit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {merit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
